import React from "react";
import ReactECharts from "echarts-for-react";
import ToolTipCompany from 'components/ui/ToolTipCompany';

const TradingViewGaugeECharts = ({ score = 50 , signal_status }) => {


    const getSignal = (v) => {
      if(signal_status == 'bearish') return "Bearish";
      if(signal_status == 'strong_bearish') return "Strong Bearish";
      if(signal_status == 'neutral') return "Neutral";
      if(signal_status == 'mild_bullish') return "Mild bullish";
      if(signal_status == 'bullish') return "Bullish";
      if(signal_status == 'strong_bullish') return "Strong bullish";
return null;
  /*if (v >= 80) return "Strong Buy";
  if (v >= 60) return "Buy";
  if (v >= 45) return "Mild Buy";
  if (v >= 30) return "Mild Sell";
  if (v >= 15) return "Sell";
  return "Strong Sell";
  */
 return signal_status;
};

/*
const labels = [
  "Strong Sell",
  "Sell",
  "Mild Sell",
  "Mild Buy",
  "Buy",
  "Strong Buy",
];
*/


  const option = {
    responsive: true,
    maintainAspectRatio: false,

    series: [
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        min: 0,
        max: 100,
        splitNumber: 6,
        radius: "90%",
        center: ["50%", "65%"],

        axisLine: {
          lineStyle: {
            width: 22,
            color: [
              [0.15, "#b71c1c"], // Strong Sell
              [0.30, "#e53935"], // Sell
              [0.45, "#fb8c00"], // Mild Sell
              [0.60, "#fdd835"], // Mild Buy
              [0.80, "#7cb342"], // Buy
              [1.00, "#2e7d32"], // Strong Buy
            ],
          },
        },

        pointer: {
          icon: "rect",
          length: "60%",
          width: 6,
        },

        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },

        detail: {
          formatter: () => getSignal(score),
          fontSize: 18,
          fontWeight: 600,
          offsetCenter: [0, "20%"],
          valueAnimation: true,
        },

        data: [{ value: score }],
      },
    ],
  };

  return (
    <>  
    <div className="flex justify-center">
    <ToolTipCompany 
        content ={"Score and Signal calculated use different technical parameter DMA50 , DMA 200 , Avg Volume 14 Days , RSA 14 days  "}
        />
    </div>
    <div style={{ width: "100%", height: 260 }}>
      <ReactECharts
        option={option}
        style={{ width: "100%", height: "100%" }}
      />
      
      
      {/*<div className="flex justify-between text-xs font-medium mt-1 px-2">
  {labels.map((l) => (
    <span key={l}>{l}</span>
  ))}
</div>*/}

    </div>
     
    </>
  );
};

export default TradingViewGaugeECharts;
